import { t } from '@/i18n';
import { z } from 'zod';

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const modalFormSchema = z
  .object({
    title: z.string().min(1, t('pages.application_banner.components.banner_create_modal.schema.title_required')),
    source_url: z.string().min(1, t('pages.application_banner.components.banner_create_modal.schema.url_required')),
    is_scheduled: z.boolean().optional(),
    has_partner: z.boolean().optional(),
    partner_uuid: z.string().optional(),
    team_uuid: z.string().optional(),
    file: z
      .any()
      .refine(
        file => (file && ACCEPTED_IMAGE_TYPES.includes(file.type)) || !file,
        t('pages.application_banner.components.banner_create_modal.schema.invalid_image'),
      ),
    start_at: z
      .string()
      .optional()
      .transform(value => (value === '' ? undefined : value)),
    end_at: z
      .string()
      .optional()
      .transform(value => (value === '' ? undefined : value)),
  })
  .superRefine((values, ctx) => {
    if (values.is_scheduled && (!values?.start_at || !values?.end_at)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['publish_at'],
        message: t('pages.application_banner.components.banner_create_modal.schema.period_required'),
      });
    }

    if (values.has_partner && !values?.partner_uuid) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['partner_uuid'],
        message: t('pages.application_banner.components.banner_create_modal.schema.partner_required'),
      });
    }

    if (!values.file) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['file'],
        message: t('pages.application_banner.components.banner_create_modal.schema.image_required'),
      });
    }
  });

export type ModalFormData = z.infer<typeof modalFormSchema>;
